import _ from "lodash";
import axios from "axios";
import store from "../store";

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

const API = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 29000
});

const POST = (uri, params, headers = {}) => {
  return new Promise((resolve, reject) => {
    API.post(uri, params, { headers })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        error = error.response;
        let errors = {};

        switch (error.status) {
          case 422:
            _.each(error.data, (item, key) => (errors[key] = _.head(item)));

            reject({
              status: error.status,
              errors
            });

            break;
          case 404:
          case 401:
            reject({
              status: error.status,
              errors: {
                message: error.data.message
              }
            });
            break;
          case 503:
            store.dispatch("merchant/fetchMerchantMaintenance");
            break;
          case 419:
            // store.dispatch("auth/logout");
            break;
          case 400:
            reject({
              status: error.status,
              errors: {
                message: error.data.message,
                data: error.data.data
              }
            });
            break;
          default:
            reject({
              status: 500,
              errors: {
                message: "Something went wrong, please try again"
              }
            });
        }
      });
  });
};

const GET = (uri, headers = null) => {
  return new Promise((resolve, reject) => {
    API.get(uri, {
      headers
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        error = error.response;
        let errors = {};

        switch (error.status) {
          case 503:
            store.dispatch("merchant/fetchMerchantMaintenance");
            break;
          case 419:
            reject({
              status: error.status,
              errors: {
                message: error.data.message
              }
            });
            break;
          case 422:
            _.each(error.data.errors, (item, key) => (errors[key] = item));

            reject({
              status: error.status,
              errors
            });
            break;
          case 404:
            reject({
              status: error.status,
              errors: {
                message: error.data.message
              }
            });
            break;
          case 400:
            reject({
              status: error.status,
              errors: {
                message: error.data.message
              }
            });
            break;
          default:
            reject({
              status: 500,
              errors: {
                message: "Something went wrong, please try again"
              }
            });
        }
      });
  });
};

const DELETE = (uri, headers = null) => {
  return new Promise((resolve, reject) => {
    API.delete(uri, {
      headers
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        error = error.response;
        switch (error.status) {
          case 503:
            store.dispatch("merchant/fetchMerchantMaintenance");
            break;
          case 419:
            // store.dispatch("auth/logout");
            break;
          case 400:
            reject({
              status: 400,
              errors: {
                message: error.data.message
              }
            });
            break;
          default:
            reject({
              status: 500,
              errors: {
                message: "Something went wrong, please try again"
              }
            });
        }
      });
  });
};

const MULTIPLE_DELETE = (uri, data, headers = null) => {
  return API.delete(uri, {
    headers,
    data
  });
};

const PUT = (uri, params, headers = {}) => {
  return new Promise((resolve, reject) => {
      API.put(uri, params, { headers })
          .then(response => {
              resolve(response.data);
          })
          .catch(error => {
              error = error.response;
              let errors = {};

              switch (error.status) {
                  case 422:
                      _.each(
                          error.data,
                          (item, key) => (errors[key] = _.head(item))
                      );

                      reject({
                          status: error.status,
                          errors
                      });

                      break;
                  case 404:
                  case 401:
                      reject({
                          status: error.status,
                          errors: {
                              message: error.data.message
                          }
                      });
                      break;
                  case 419:
                      store.commit("auth/logout");
                      break;
                  case 400:
                      reject({
                          status: error.status,
                          errors: {
                              message: error.data.message
                          }
                      });
                      break;
                  case 503:
                      store.dispatch("merchants/fetchMaintenance");
                      break;
                  case 409:
                      reject({
                          status: error.status,
                          errors: {
                              message: error.data.message
                          }
                      });
                      break;
                  default:
                      reject({
                          status: 500,
                          errors: {
                              message:
                                  "Something went wrong, please try again"
                          }
                      });
              }
          });
  });
};

export default {
  post: POST,
  get: GET,
  delete: DELETE,
  multipleDelete: MULTIPLE_DELETE,
  put: PUT
};
